import { Card } from "antd";
import styled, { keyframes, css } from "styled-components";
import ReactPlayer from "react-player";
const { Meta } = Card;

const fadeInFromBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const StyledCard = styled(Card)`
  opacity: 0;
  position: relative;
  z-index: 1;
  border-radius: 3%;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out,
    border 0.3s ease-in-out;
  background: linear-gradient(to right bottom, #445e7c, #050f27);
  border-color: transparent;
  ${(props) =>
    props.isVisible &&
    css`
      animation: ${fadeInFromBottom} 1s ease-out forwards;
      animation-delay: ${(props) => props.delay || 0}s;
    `}

  &:hover {
    z-index: 2;

    box-shadow: 0 0 10px 5px #00dbf8;

    ${(props) =>
      props.hovermode &&
      css`
        .ant-card-meta-description {
          max-height: 200px;
          height: auto;
          opacity: 1;
          transition: all 0.3s ease-in-out;

          color: white;
          padding: 10px 0;
        }
        ${Description} {
          color: white;
          opacity: 1;
          transition: opacity 0.3s ease-in-out;
          height: auto;
          line-height: 1.5;
        }
      `}
  }
  .ant-card-meta-title {
    color: white;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .ant-card-meta-description {
    max-height: ${(props) => (props.clicked ? "200px" : "0")};
    height: auto;
    opacity: ${(props) => (props.clicked ? "1" : "0")};
    transition: all 0.3s ease-in-out;

    color: white;
    padding: ${(props) => (props.clicked ? "10px 0" : "0")};
  }
`;

const Description = styled.div`
  color: white;
  opacity: ${(props) => (props.in || props.hover ? "1" : "0")};
  transition: opacity 0.3s ease-in-out;
  height: auto;
  line-height: 1.5;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1117/675;
  overflow: hidden;
  border-radius: 10px;

  .react-player {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }
`;

export default function InformationCard({
  option,
  isVisible,
  delay,
  clicked,
  onClick,
  isFirstItem,
  refProp,
  videoUrl,
  hovermode,
}) {
  const imgDisplay =
    !option.img.includes("youtube") && !option.img.includes("youtu.be");

  const handleClick = () => {
    if (hovermode) {
      window.open(option.link, "_blank");
    } else {
      onClick && onClick();
    }
  };
  return (
    <StyledCard
      cover={
        imgDisplay ? (
          <img
            alt="showcase"
            src={option.img}
            style={{
              borderRadius: 10,
            }}
          />
        ) : (
          <VideoContainer>
            <ReactPlayer
              url={option.img}
              playing
              playsinline
              muted
              controls
              width="100%"
              height="auto"
              loop
            />
          </VideoContainer>
        )
      }
      isVisible={isVisible}
      ref={isFirstItem ? refProp : null}
      delay={delay}
      onClick={handleClick}
      clicked={clicked}
      hovermode={hovermode}
    >
      <Meta
        title={option.title}
        description={<Description in={clicked}>{option.content}</Description>}
      />
    </StyledCard>
  );
}
